module.exports = __webpack_public_path__ + "static/front-page-11-90fb97aea0cd491acb1cbde7ea3f83a4.jpg";